import { Title, LinkDecor } from "@vshp/ui-components";

const PageDocuments = ({ files, title }) => {
  return (
    <>
      <Title type="h2">{title ? title : "Материалы для изучения"}</Title>
      <div className="wysiwyg__documents">
        {files.map((item, key) => {
          return (
            <LinkDecor className="wysiwyg__documents-item" link={item.material_source_url} key={key}>
              {item.material_source_title}
            </LinkDecor>
          );
        })}
      </div>
    </>
  );
};

export default PageDocuments;
